import * as types from './mutations_types'

export const saveCompany = (context, info) => context.commit(types.SET_COMPANY, info)

export const saveCurrencies = (context, currencies) => context.commit(types.SET_CURRENCIES, currencies)

export const setMembers = (context, members) => context.commit(types.SET_MEMBERS, members)

export const setTenant = (context, tenant) => context.commit(types.SET_TENANT, tenant)

export const saveMember = (context, member) => context.commit(types.SAVE_MEMBER, member)

export const destroyMember = (context, id) => context.commit(types.DESTROY_MEMBER, id)



// WEBPACK FOOTER //
// ./src/modules/company/store/actions.js